import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import PageShell from "../../components/UI/PageShell";

const Setting = ({ history }) => {
  const { t } = useTranslation();
  return (
    <PageShell
      title={t("Settings")}
      eyebrow="Account"
      description="Manage your profile, security, and language preferences."
    >
      <div className="portal-settings-grid">
        {[
          { label: t("Profile"), detail: "Personal and employment details", icon: "fa-user", path: "/profile" },
          { label: t("Change Password"), detail: "Update your account password", icon: "fa-lock", path: "/changePassword" },
          { label: t("Choose Language"), detail: "Set your preferred language", icon: "fa-language", path: "/chooseLanguage" },
        ].map((item) => (
          <button
            type="button"
            key={item.path}
            onClick={() => history.push(item.path)}
            className="portal-settings-card"
          >
            <span className="portal-settings-card__icon" aria-hidden="true">
              <i className={`fas ${item.icon}`} />
            </span>
            <span>
              <strong>{item.label}</strong>
              <small>{item.detail}</small>
            </span>
            <i className="fas fa-chevron-right" aria-hidden="true" />
          </button>
        ))}
        <button
          type="button"
          onClick={() => history.push("/logout")}
          className="portal-settings-card portal-settings-card--danger"
        >
          <span className="portal-settings-card__icon" aria-hidden="true">
            <i className="fas fa-sign-out-alt" />
          </span>
          <span>
            <strong>{t("Log Out")}</strong>
            <small>Securely end this session</small>
          </span>
          <i className="fas fa-chevron-right" aria-hidden="true" />
        </button>
      </div>
    </PageShell>
  );
};

export default withRouter(Setting);
